import { render, staticRenderFns } from "./QuickTipsDataMarts.vue?vue&type=template&id=71cb0392&scoped=true&"
import script from "./QuickTipsDataMarts.vue?vue&type=script&lang=js&"
export * from "./QuickTipsDataMarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb0392",
  null
  
)

export default component.exports